export async function apiCall(url: string, method: 'GET' | 'POST' |'DELETE' | 'PUT' = 'GET', body?: any): Promise<any> {
    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json', // Assuming JSON data
            // Add any additional headers if needed
        }
    };

    if (!!body) {
        options.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        // Check if the response status is 204 No Content
        if (response.status === 204) {
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error('There was a problem with the API call:', error);
        throw error;
    }
}

// utils.ts
export const updateUrlParameter = (param: string, value: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value);
    window.history.pushState({}, '', url.toString());
};

export const getUrlParameter = (param: string): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};

export const removeUrlParameter = (param: string) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.pushState({}, '', url.toString());
};